import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid } from "@mui/material"
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Employee, Office } from "../../interfaces/s10Corporation.interface";
import { useEffect, useState } from "react";
import { DeleteNodeData } from ".";
import MyTextField from "../../components/MyTextField";
import { Company } from "../../interfaces/auth.interface";
import { deleteOrganizationEmployee, deleteOrganizationOffice } from "../../api/s10OrganizationApi";

interface DeleteNodeModalProps {
    company: Company;
    officeData?: Office | null;
    employeeData?: Employee | null;
    onCancel: () => void;
    setDeletedNode: (data: DeleteNodeData) => void,
}

const DeleteNodeModal = ({onCancel, company, setDeletedNode, officeData, employeeData}: DeleteNodeModalProps) => {

    const [error, setError] = useState<string>('');

    useEffect(() => {
        if (!officeData) {
            return;
        }
        console.log(officeData)
        if (officeData.offices?.filter(f => f.isAddOption !== true).length) {
            setError("No es posible eliminar la gerencia, debes eliminar las sub gerencias primero.")
        }
    }, [officeData]);

    const handleDeleteOffice = async () => {
        const officeId = officeData?.Id as any;
        const result = await deleteOrganizationOffice(officeId)
        console.log(result)
        if (result?.data?.Type !== 0) {
            setDeletedNode({
                success: false,
                message: result?.data?.Message || "Ocurrió un error eliminando la gerencia",
            });
            return;
        }
        setDeletedNode({
            success: true,
            message: result?.data?.Message || "Gerencia eliminada",
            officeIds: [officeId],
            parentId: officeData?.parentData?.Id as any,
        });
    }

    const handleDeleteEmployee = async () => {
        const ids = employeeData?.Id as any;
        const result = await deleteOrganizationEmployee([ids])
        console.log(result)
        if (result?.data?.Type !== 0) {
            setDeletedNode({
                success: false,
                message: result?.data?.Message || "Ocurrió un error registrando el colaborador",
            });
            return;
        }
        setDeletedNode({
            success: true,
            message: result?.data?.Message || "Colaborador eliminado",
            employeeIds: [ids],
            parentId: employeeData?.parentData?.Id as any,
        });
    }

    return (<Dialog
        open={true}
        aria-labelledby="responsive-dialog-title"
        style={{width: "100%"}}
    >
        <DialogTitle
            id="responsive-dialog-title" 
            style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
            variant="h5"
        >
            Eliminar{" "}{employeeData ? "colaborador" : "gerencia"}
        </DialogTitle>
        <DialogContent style={{width: "25rem", textAlign: "center"}}>
            <Grid container spacing="1.5rem">
                <Grid item xs={12} style={{maxWidth: "25rem"}}>
                    <FormControl error={!!error} fullWidth >
                        <MyTextField
                            style={{width: "100%"}} 
                            label="Nombre"
                            value={officeData?.Name || (employeeData as any).Descripcion}
                            disabled={true}
                        />
                        {error && <FormHelperText id="collaborator-search-error">{error}</FormHelperText>}
                    </FormControl>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Grid 
                container 
                direction="row"
                justifyContent="space-between"
                margin={"0.5rem 1rem 2rem 1rem"}
            >
                <Grid item >
                    <Button
                        variant="outlined" 
                        style={{width: "8rem"}}
                        startIcon={<CloseIcon style={{height: "1rem"}} />}
                        onClick={onCancel}
                    >
                        Cancelar
                    </Button>
                </Grid>
                <Grid item textAlign={"right"} marginLeft={"1rem"}>
                    <Button 
                        variant="contained" 
                        color={"error"}
                        style={{width: "8rem"}}
                        startIcon={<CheckIcon style={{height: "1rem"}} />}
                        disabled={!!error}
                        onClick={async () => {
                            if (officeData) {
                                await handleDeleteOffice();
                            } else if (employeeData) {
                                await handleDeleteEmployee();
                            }
                        }}
                    >
                        Eliminar
                    </Button>
                </Grid>
            </Grid>
        </DialogActions>
    </Dialog>)
}

export default DeleteNodeModal